<twc-popup caption="{{templateService.titleTemplate | translate}}" width="xl" type="primary">
    <twc-popup-content>
        <div class="twc-ml-2" [innerHTML]="templateService.contentTemplate"></div>
    </twc-popup-content>
</twc-popup>